module.exports = __webpack_public_path__ + "static/media/sg_1.b4cacc88.wav";